
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { SocialPlatform } from '@/types/link-short';

const socialPlatforms: SocialPlatform[] = [
  {
    name: 'Instagram',
    value: 'instagram',
    icon: '📷',
    color: '#E4405F',
    placeholder: 'https://instagram.com/seuusuario'
  },
  {
    name: 'TikTok',
    value: 'tiktok',
    icon: '🎵',
    color: '#000000',
    placeholder: 'https://tiktok.com/@seuusuario'
  },
  {
    name: 'YouTube',
    value: 'youtube',
    icon: '🎥',
    color: '#FF0000',
    placeholder: 'https://youtube.com/@seucanal'
  },
  {
    name: 'Twitter/X',
    value: 'twitter',
    icon: '🐦',
    color: '#1DA1F2',
    placeholder: 'https://twitter.com/seuusuario'
  },
  {
    name: 'LinkedIn',
    value: 'linkedin',
    icon: '💼',
    color: '#0077B5',
    placeholder: 'https://linkedin.com/in/seuperfil'
  },
  {
    name: 'Facebook',
    value: 'facebook',
    icon: '👥',
    color: '#1877F2',
    placeholder: 'https://facebook.com/suapagina'
  },
  {
    name: 'WhatsApp',
    value: 'whatsapp',
    icon: '💬',
    color: '#25D366',
    placeholder: 'https://wa.me/5511999999999'
  },
  {
    name: 'Telegram',
    value: 'telegram',
    icon: '✈️',
    color: '#0088CC',
    placeholder: 'https://t.me/seuusuario'
  },
  {
    name: 'Spotify',
    value: 'spotify',
    icon: '🎧',
    color: '#1DB954',
    placeholder: 'https://open.spotify.com/artist/...'
  },
  {
    name: 'Website',
    value: 'website',
    icon: '🌐',
    color: '#6B7280',
    placeholder: 'https://seusite.com'
  },
  {
    name: 'Email',
    value: 'email',
    icon: '📧',
    color: '#EF4444',
    placeholder: 'mailto:seu@email.com'
  },
  {
    name: 'Telefone',
    value: 'phone',
    icon: '📞',
    color: '#10B981',
    placeholder: 'tel:+5511999999999'
  }
];

interface SocialTemplatesProps {
  onSelect: (platform: SocialPlatform) => void;
}

export function SocialTemplates({ onSelect }: SocialTemplatesProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium text-gray-700">Templates de Redes Sociais</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {socialPlatforms.map((platform) => (
          <Button
            key={platform.value}
            variant="outline"
            size="sm"
            className="h-auto p-3 flex flex-col items-center gap-2 hover:shadow-md transition-all"
            onClick={() => onSelect(platform)}
          >
            <span className="text-lg">{platform.icon}</span>
            <span className="text-xs font-medium">{platform.name}</span>
          </Button>
        ))}
      </div>
    </div>
  );
}

export { socialPlatforms };
